package app.footyguide.core.theme

data class Club(
    val slug: String,
    val name: String,
    val fullName: String = name,
    val initials: String,
    val nickname: String = name,
    val c1: String,
    val c2: String,
    val c3: String? = null,
    val logoUrl: String = "https://storage.googleapis.com/footy-guide.firebasestorage.app/public/logos/teams/$slug.webp?alt=media",
    val aliases: List<String> = emptyList(),
    val aleflyTenantId: String = slug,
    val aleflyIconUrl: String = "https://alefly.app/icons/home-tenants/$slug.webp",
    val aleflyQuizUrl: String = "https://alefly.app/$aleflyTenantId",
    val hasAleflyQuiz: Boolean = false,
)

object ClubCatalog {
    val NEUTRAL = Club(
        slug = "neutral",
        name = "FootyGuide",
        fullName = "FootyGuide Sports",
        initials = "FG",
        nickname = "Guia",
        c1 = "#0B6E4F",
        c2 = "#084C37",
        aliases = listOf("footyguide", "fg", "guia"),
    )

    val CLUBS: List<Club> = listOf(
        Club(
            slug = "flamengo",
            name = "Flamengo",
            fullName = "Clube de Regatas do Flamengo",
            initials = "FLA",
            nickname = "Mengão",
            c1 = "#C62828",
            c2 = "#111111",
            c3 = "#FFFFFF",
            aliases = listOf("flamengo", "cr-flamengo", "cr flamengo", "fla", "mengo", "mengao"),
            hasAleflyQuiz = true,
        ),
        Club(
            slug = "palmeiras",
            name = "Palmeiras",
            fullName = "Sociedade Esportiva Palmeiras",
            initials = "PAL",
            nickname = "Verdão",
            c1 = "#006437",
            c2 = "#FFFFFF",
            c3 = "#00A859",
            aliases = listOf("palmeiras", "se-palmeiras", "se palmeiras", "pal", "verdao"),
            hasAleflyQuiz = true,
        ),
        Club(
            slug = "saopaulo",
            name = "São Paulo",
            fullName = "São Paulo Futebol Clube",
            initials = "SAO",
            nickname = "Tricolor",
            c1 = "#C4122D",
            c2 = "#111111",
            c3 = "#FFFFFF",
            aliases = listOf("sao paulo", "são paulo", "sao-paulo", "saopaulo", "sao-paulo-fc", "sao paulo fc", "spfc"),
            hasAleflyQuiz = true,
        ),
        Club(
            slug = "corinthians",
            name = "Corinthians",
            fullName = "Sport Club Corinthians Paulista",
            initials = "COR",
            nickname = "Timão",
            c1 = "#111111",
            c2 = "#FFFFFF",
            c3 = "#ED1C2E",
            aliases = listOf("corinthians", "sc-corinthians-paulista", "sc corinthians", "cor", "timao"),
            hasAleflyQuiz = true,
        ),
        Club(
            slug = "vasco",
            name = "Vasco",
            fullName = "Club de Regatas Vasco da Gama",
            initials = "VAS",
            nickname = "Gigante da Colina",
            c1 = "#111111",
            c2 = "#FFFFFF",
            c3 = "#C62828",
            aliases = listOf("vasco", "vasco da gama", "cr-vasco-da-gama", "vas", "gigante"),
            hasAleflyQuiz = true,
        ),
        Club(
            slug = "fluminense",
            name = "Fluminense",
            fullName = "Fluminense Football Club",
            initials = "FLU",
            nickname = "Tricolor",
            c1 = "#7A1E2C",
            c2 = "#00613C",
            c3 = "#FFFFFF",
            aliases = listOf("fluminense", "fluminense-fc", "flu", "fluminense fc"),
            hasAleflyQuiz = true,
        ),
        Club(
            slug = "botafogo",
            name = "Botafogo",
            fullName = "Botafogo de Futebol e Regatas",
            initials = "BOT",
            nickname = "Glorioso",
            c1 = "#111111",
            c2 = "#FFFFFF",
            aliases = listOf("botafogo", "botafogo-fr", "bot", "glorioso", "botafogo fr"),
            hasAleflyQuiz = true,
        ),
        Club(
            slug = "atleticomg",
            name = "Atlético-MG",
            fullName = "Clube Atlético Mineiro",
            initials = "CAM",
            nickname = "Galo",
            c1 = "#111111",
            c2 = "#FFFFFF",
            c3 = "#FFD503",
            aliases = listOf("atletico-mg", "atlético-mg", "atletico mineiro", "atlético mineiro", "galo", "cam", "atleticomg"),
            hasAleflyQuiz = true,
        ),
        Club(
            slug = "cruzeiro",
            name = "Cruzeiro",
            fullName = "Cruzeiro Esporte Clube",
            initials = "CRU",
            nickname = "Raposa",
            c1 = "#003B7A",
            c2 = "#FFFFFF",
            aliases = listOf("cruzeiro", "cruzeiro-ec", "cru", "raposa", "cruzeiro ec"),
            hasAleflyQuiz = true,
        ),
        Club(
            slug = "gremio",
            name = "Grêmio",
            fullName = "Grêmio Foot-Ball Porto Alegrense",
            initials = "GRE",
            nickname = "Imortal",
            c1 = "#0D80BF",
            c2 = "#111111",
            c3 = "#FFFFFF",
            aliases = listOf("gremio", "grêmio", "gremio-fbpa", "gre", "imortal", "gremio fbpa"),
            hasAleflyQuiz = true,
        ),
        Club(
            slug = "internacional",
            name = "Internacional",
            fullName = "Sport Club Internacional",
            initials = "INT",
            nickname = "Colorado",
            c1 = "#E51A22",
            c2 = "#FFFFFF",
            aliases = listOf("internacional", "inter", "sc-internacional", "int", "colorado", "sc internacional"),
            hasAleflyQuiz = true,
        ),
        Club(
            slug = "bahia",
            name = "Bahia",
            fullName = "Esporte Clube Bahia",
            initials = "BAH",
            nickname = "Tricolor de Aço",
            c1 = "#005DAA",
            c2 = "#E0242B",
            c3 = "#FFFFFF",
            aliases = listOf("bahia", "ec-bahia", "bah", "esquadrao", "ec bahia"),
        ),
        Club(
            slug = "athleticopr",
            name = "Athletico-PR",
            fullName = "Club Athletico Paranaense",
            initials = "CAP",
            nickname = "Furacão",
            c1 = "#C8102E",
            c2 = "#111111",
            aliases = listOf("athletico-pr", "athleticopr", "atletico paranaense", "athletico paranaense", "furacao", "cap"),
        ),
        Club(
            slug = "bragantino",
            name = "RB Bragantino",
            fullName = "Red Bull Bragantino",
            initials = "RBB",
            nickname = "Massa Bruta",
            c1 = "#D2003C",
            c2 = "#FFFFFF",
            c3 = "#FFCC00",
            aliases = listOf("bragantino", "rb bragantino", "red bull bragantino", "rbb"),
        ),
        Club(
            slug = "vitoria",
            name = "Vitória",
            fullName = "Esporte Clube Vitória",
            initials = "VIT",
            nickname = "Leão da Barra",
            c1 = "#FF1100",
            c2 = "#111111",
            aliases = listOf("vitoria", "vitória", "ec-vitoria", "vit", "ec vitoria"),
        ),
        Club(
            slug = "santos",
            name = "Santos",
            fullName = "Santos Futebol Clube",
            initials = "SAN",
            nickname = "Peixe",
            c1 = "#111111",
            c2 = "#FFFFFF",
            c3 = "#C69F0F",
            aliases = listOf("santos", "santos-fc", "san", "peixe", "santos fc"),
            hasAleflyQuiz = true,
        ),
        Club(
            slug = "chapecoense",
            name = "Chapecoense",
            fullName = "Associação Chapecoense de Futebol",
            initials = "CHA",
            nickname = "Chape",
            c1 = "#00A859",
            c2 = "#FFFFFF",
            aliases = listOf("chapecoense", "chapecoense-af", "cha", "chape", "chapecoense af"),
        ),
        Club(
            slug = "coritiba",
            name = "Coritiba",
            fullName = "Coritiba Foot Ball Club",
            initials = "CFC",
            nickname = "Coxa",
            c1 = "#00544D",
            c2 = "#FFFFFF",
            aliases = listOf("coritiba", "coritiba-fbc", "cfc", "coxa", "coritiba fbc"),
        ),
        Club(
            slug = "mirassol",
            name = "Mirassol",
            fullName = "Mirassol Futebol Clube",
            initials = "MIR",
            nickname = "Leão",
            c1 = "#FFCC00",
            c2 = "#005A36",
            aliases = listOf("mirassol", "mirassol-fc", "mir", "mirassol fc"),
        ),
        Club(
            slug = "remo",
            name = "Remo",
            fullName = "Clube do Remo",
            initials = "REM",
            nickname = "Leão Azul",
            c1 = "#051644",
            c2 = "#FFFFFF",
            c3 = "#C9992B",
            aliases = listOf("remo", "clube do remo", "clube-do-remo", "rem"),
        ),
    )

    fun bySlug(slug: String): Club? {
        val clean = slug.trim().lowercase()
        return CLUBS.find { it.slug == clean || it.aliases.any { a -> a.lowercase() == clean } }
    }

    fun findByQuery(query: String): Club? {
        val clean = query.trim().lowercase()
        if (clean.isBlank()) return null
        return CLUBS.find { club ->
            club.slug == clean ||
                club.name.lowercase() == clean ||
                club.fullName.lowercase() == clean ||
                club.initials.lowercase() == clean ||
                club.nickname.lowercase() == clean ||
                club.aleflyTenantId == clean ||
                club.aliases.any { it.lowercase() == clean }
        }
    }
}
